import { Helmet } from "react-helmet-async";

function normalizeCanonicalUrl(canonical) {
  const value = String(canonical || "").trim();
  if (!value) return value;

  try {
    return new URL(value).toString();
  } catch {
    return value;
  }
}

function SEO({
  title,
  description,
  canonical,
  image,
  imageAlt,
  siteName,
  locale,
  robots,
}) {
  const normalizedCanonical = normalizeCanonicalUrl(canonical);

  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta name="description" content={description} />
        <meta name="robots" content={robots} />
        <link rel="canonical" href={normalizedCanonical} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={siteName} />
        <meta property="og:locale" content={locale} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={normalizedCanonical} />
        <meta property="og:image" content={image} />
        <meta property="og:image:alt" content={imageAlt} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:image:alt" content={imageAlt} />
      </Helmet>
    </>
  );
}

export default SEO;
